module.exports = __webpack_public_path__ + "img/Carte-platinum-noire-ccs.690d1bbe.png";